module.exports = __webpack_public_path__ + "img/stock4.b3466edb.png";